import { createApp } from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
// router
import Router from './global-router/index';

// Store
import PiniaStore from './global-store/index';

import CustomPlugins from './plugins.conf';

import CustomDirectives from './global-directives/index';

import 'ant-design-vue/dist/reset.css';

// 样式
import './global-styles/index.less';
// 字体图标
import './global-assets/iconfont/iconfont.css';

// 路由拦截
import './global-router/route-before-each';

const app = createApp(App);

// 去掉Vue warn警告
app.config.warnHandler = (): any => null;

app.use(Router).use(PiniaStore).use(CustomPlugins).use(CustomDirectives).use(Antd).mount('#app');
